import { render, staticRenderFns } from "./ProjectDesc.vue?vue&type=template&id=699017d6&scoped=true&"
import script from "./ProjectDesc.vue?vue&type=script&lang=ts&"
export * from "./ProjectDesc.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDesc.vue?vue&type=style&index=0&id=699017d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699017d6",
  null
  
)

export default component.exports